<template>
  <section class="table-data-filter-radio fx-v-center">
    <div class="header fx-h-between" ref="refrence" @click.stop="switchSelect">
      <span>{{ title }}</span>
      <i class="el-icon el-icon-caret-bottom" />
    </div>
    <transition name="height-fade">
      <div
        class="table-data-filter-radio-container"
        ref="popper"
        :style="{ height: height, 'z-index': zIndex }"
        v-show="show"
        @click.stop
      >
        <div class="container-top">
          <div class="all-type fx-v-center" @click="showThisOne(firstItem)">
            <my-radio :label="firstItem[itemKeyCode]" v-model="radioVal">
              <template v-if="isObject(firstItem[itemKeyName])">
                <slot :row="firstItem[itemKeyName]" />
              </template>
              <template v-else>
                {{ firstItem[itemKeyName] }}
              </template>
            </my-radio>
            <span
              class="arrow arrow-animate"
              @click.stop="confirmByArrow(firstItem)"
            >
              <img
                src="~@/assets/images/a20.png"
                alt=""
                :key="i"
                v-for="i in 3"
              />
            </span>
          </div>
          <i class="line" />
          <el-input
            placeholder="输入关键词搜索"
            v-model="elVal"
            @input="debounceSearchByKeyWords"
            v-if="showSearch"
          />
        </div>
        <dynamic-scroller
          :items="listItem"
          :min-item-size="28"
          :key-field="itemKey || itemKeyCode"
          class="scroller"
          :class="{ 'scroller-width-search': showSearch }"
        >
          <template v-slot="{ item, index, active }">
            <dynamic-scroller-item
              :item="item"
              :active="active"
              :size-dependencies="[item[itemKeyName]]"
              class="item"
              :data-index="index"
              @click.native.stop="showThisOne(item)"
            >
              <my-radio :label="item[itemKeyCode]" v-model="radioVal">
                <template v-if="isObject(item[itemKeyName])">
                  <slot :row="item[itemKeyName]" />
                </template>
                <template v-else>
                  {{ item[itemKeyName] }}
                </template>
              </my-radio>
              <span
                class="arrow arrow-animate"
                @click.stop="confirmByArrow(item)"
              >
                <img
                  src="~@/assets/images/a20.png"
                  alt=""
                  :key="i"
                  v-for="i in 3"
                />
              </span>
            </dynamic-scroller-item>
          </template>
        </dynamic-scroller>
        <div class="btn-wrapper">
          <i class="line" />
          <button class="btn confirm" @click="confirm">确认</button>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import event from "@/utils/event";
import { deepClone } from "@/utils/clone";
import { isString } from "@/utils/type";
import { debounce } from "@/utils/debounce";
import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";
import Popper from "popper.js";
import "vue-virtual-scroller/dist/vue-virtual-scroller.css";

// img
import arrow from "@/assets/images/a20.png";
export default {
  data() {
    return {
      arrow,
      show: false,
      elVal: "",
      olistItem: null,
    };
  },
  props: {
    zIndex: {
      type: [String, Number],
      default: 1999,
    },
    height: {
      type: String,
      default: "380px",
    },
    title: String,
    items: Array,
    itemKeyName: String, // 如果itemKeyName属性对应的值是对象或数组类型，那么会被认为使用slot，值会通过slot-scope传出去
    itemKeyCode: [String, Number, Boolean],
    itemKey: [String, Number, Boolean],
    value: [String, Number],
    showSearch: Boolean,
    searchKey: [Array, String], // 搜索一个prop可以写成字符串
  },
  computed: {
    radioVal: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("change", val);
        this.$emit("input", val);
      },
    },

    listItem: {
      get() {
        if (this.olistItem) {
          return this.olistItem;
        } else {
          return this.allListItem;
        }
      },

      set(val) {
        this.olistItem = val;
      },
    },

    allListItem() {
      return deepClone(this.items.slice(1));
    },

    firstItem() {
      return deepClone(this.items[0]);
    },

    isObject() {
      // 数组对象都行
      return function (o) {
        return typeof o === "object";
      };
    },
  },
  created() {
    this.debounceSearchByKeyWords = debounce(this.searchByKeyWords);
    this.symbol = Symbol("tableDataFilterSymbol"); // 用于关闭非自身表头筛选
    event.$on("TABLE_DATA_FILTER_CLICK", this.listenOtherTableFilterClick);
  },
  mounted() {
    document.addEventListener("click", this.documentClick, false);
    document.body.appendChild(this.$refs.popper);
    this.popper = new Popper(
      {
        getBoundingClientRect: () =>
          this.$refs.refrence.getBoundingClientRect(),
        clientWidth: this.$refs.refrence.clientWidth,
        clientHeight: this.$refs.refrence.clientHeight,
      },
      this.$refs.popper,
      {
        placement: "bottom-start",
        modifiers: {
          offset: {
            offset: "0, 10px, 0, 0",
          },
        },
      }
    );
  },
  beforeDestroy() {
    document.removeEventListener("click", this.documentClick);
    event.$off("TABLE_DATA_FILTER_CLICK", this.listenOtherTableFilterClick);
    if (document.body.contains(this.$refs.popper)) {
      document.body.removeChild(this.$refs.popper);
    }
  },
  methods: {
    close() {
      this.show = false;
    },

    open() {
      event.$emit("TABLE_DATA_FILTER_CLICK", this.symbol);
      this.show = true;
    },

    documentClick() {
      this.show = false;
    },

    switchSelect() {
      document.getElementById("app").click();
      if (this.show === true) {
        return (this.show = false);
      }
      this.open();
      this.popper.update();
    },

    showThisOne(item) {
      this.radioVal = item[this.itemKeyCode];
    },

    confirm() {
      this.show = false;
      this.$emit("confirm", this.radioVal);
    },

    confirmByArrow(item) {
      this.showThisOne(item);
      this.confirm();
    },

    listenOtherTableFilterClick(symbol) {
      if (symbol !== this.symbol) {
        this.close();
      }
    },

    searchByKeyWords() {
      if (this.elVal === "")
        return (this.listItem = deepClone(this.items.slice(1)));
      const prop = this.itemKeyName;
      const searchedList = [];
      this.allListItem.forEach((el) => {
        let str = "";
        // 下面的if else 是寻找关键词操作
        if (this.isObject(el[prop])) {
          for (let _prop in el[prop]) {
            if (!el[prop].hasOwnProperty(_prop)) {
              continue;
            }
            let arr = [];
            if (isString(this.searchKey)) {
              arr = [this.searchKey];
            } else {
              arr = this.searchKey;
            }
            if (arr.includes(_prop)) {
              str += el[prop][_prop];
            }
          }
        } else {
          str += el[prop];
        }
        if (str.indexOf(this.elVal) !== -1) {
          searchedList.push(el);
        }
      });
      this.listItem = searchedList;
    },
  },
  components: {
    DynamicScroller,
    DynamicScrollerItem,
  },
};
</script>

<style lang="scss">
.table-data-filter-radio-container {
  position: relative;
  width: 240px;
  height: 380px;
  padding: 0 !important;
  background: #fff;
  color: #333;
  z-index: 1999;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
  font-size: 14px;
  font-weight: bold;

  ::v-deep .el-input {
    padding: 6px 10px;
    font-size: 14px;

    .el-input__inner {
      padding: 0 8px;
      height: 32px;
      line-height: 32px;
    }
  }

  ::v-deep .vue-recycle-scroller__item-wrapper {
    height: 100%;
  }

  .scroller {
    height: calc(100% - 37px);

    &.scroller-width-search {
      height: calc(100% - 81px);
    }
  }

  .item {
    ::v-deep label {
      width: calc(100% - 60px);
      font-weight: normal;
    }
  }

  .item,
  .all-type {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 36px;
    padding: 0 10px;

    &:hover {
      background: #f7f7f7;
      .arrow {
        visibility: visible;
      }
    }
  }

  .arrow {
    visibility: hidden;
    margin-left: 6px;
    margin-right: 6px;
    cursor: pointer;

    img {
      display: inline-block;
      width: 8px;
    }
  }

  .arrow-animate {
    @for $i from 1 through 3 {
      img:nth-of-type(#{$i}) {
        animation: twinkle#{$i} 1s infinite;
        animation-delay: 0.2s * $i;
      }

      @keyframes twinkle#{$i} {
        0% {
          opacity: 0;
        }

        50% {
          opacity: 1;
        }

        100% {
          opacity: 0;
        }
      }
    }
  }

  .line {
    display: block;
    height: 1px;
    background: #ebebeb;
  }

  .btn-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0;
    height: 50px;
    text-align: center;
  }

  .confirm {
    display: inline-block;
    margin-top: 10px;
    width: 180px;
    height: 30px;
    background: #009688;
    border-radius: 3px;
    color: #fff;
    font-size: 14px;
  }
}
</style>

<style lang="scss" scoped>
.table-data-filter-radio {
  position: relative;
  z-index: 1999;

  .header {
    display: flex !important;
    width: 100%;
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    background: #fff;

    > i {
      line-height: 28px;
    }
  }
}

.height-fade-enter-active {
  transition: height 0.3s ease, opacity 0.3s ease;
}

.height-fade-leave-active {
  transition: height 0.3s ease, opacity 0.3s ease;
}

.height-fade-enter,
.height-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  height: 100px !important;
  opacity: 0;
}
</style>
